// extracted by mini-css-extract-plugin
export default {"logoWrapper":"WidgetTitle_logoWrapper__uQdx2","wrapper":"WidgetTitle_wrapper__+zTb7","titleWrapper":"WidgetTitle_titleWrapper__Znwgo","title":"WidgetTitle_title__R8zL5"};